import React from 'react';
import ReleasePrintA5MoneyLender, { RELEASE_A5_MONEY_LENDER } from './ReleasePrintA5MoneyLender';

const ReleasePrintA4Simple = ({ pledgeData, releaseData, companyData }) => {
  if (!releaseData) return null;
  const principal = Number(releaseData?.calculations?.principle) || 0;
  const interest = Number(releaseData?.calculations?.interest) || 0;
  const total = Number(releaseData?.calculations?.total) || principal + interest;
  const name =
    releaseData?.client?.name ||
    [pledgeData?.customer?.firstName, pledgeData?.customer?.lastName].filter(Boolean).join(' ') ||
    '—';

  return (
    <div style={{ padding: '12mm', fontFamily: 'Arial, sans-serif', fontSize: '12px' }}>
      <h2 style={{ margin: '0 0 8px' }}>Release Receipt</h2>
      <p>
        <strong>Date:</strong> {releaseData.releaseDate ? new Date(releaseData.releaseDate).toLocaleDateString('en-GB') : '—'}
      </p>
      <p>
        <strong>Ticket:</strong> {releaseData.ticketNo || pledgeData?.loanDetails?.ticketNo || '—'}
      </p>
      <p>
        <strong>Customer:</strong> {name}
      </p>
      <p>
        <strong>Principal (Rs.):</strong> {principal.toFixed(2)}
      </p>
      <p>
        <strong>Interest (Rs.):</strong> {interest.toFixed(2)}
      </p>
      <p>
        <strong>Total (Rs.):</strong> {total.toFixed(2)}
      </p>
      <p style={{ marginTop: '16px' }}>
        <strong>Status:</strong> RELEASED
      </p>
      {companyData?.companyName ? (
        <p style={{ marginTop: '20px', fontSize: '10px', color: '#555' }}>{companyData.companyName}</p>
      ) : null}
    </div>
  );
};

/**
 * Release print: A5 money-lender layout when printer settings → Release → A5 + template; otherwise A4-style block.
 */
const ReleasePrint = ({ pledgeData, releaseData, companyData, printerType, releaseTemplateVariant }) => {
  if (printerType === 'DOT_MATRIX') {
    return <ReleasePrintA4Simple pledgeData={pledgeData} releaseData={releaseData} companyData={companyData} />;
  }
  if (releaseTemplateVariant === RELEASE_A5_MONEY_LENDER) {
    return (
      <ReleasePrintA5MoneyLender pledgeData={pledgeData} releaseData={releaseData} companyData={companyData} />
    );
  }
  return <ReleasePrintA4Simple pledgeData={pledgeData} releaseData={releaseData} companyData={companyData} />;
};

export default ReleasePrint;
